import React from 'react'

import {
  LntButton,
  LntModal,
  LntForm,
  LntFormItem,
  LntTextArea,
  LntDivider,
  LntSelect,
  LntModalFooter
} from '@app/components/base'

import { LOCATION_KEY, MONITORINGS_TYPES_KEY } from '@app/constants/queryKeys'
import { FILTERS_PLACEHOLDERS } from '@app/constants/filters'
import { BUTTON_TYPE, SIZE } from '@app/constants'

import { getTypes } from '@app/api/routes/monitorings'
import { getClusterGroups } from '@app/api/routes/locationClusterGroups'
import { getClusters } from '@app/api/routes/locationСlusters'
import { getStores } from '@app/api/routes/locationStores'

import { getFilterFromEntities } from '@app/utils/entitiesAdapters'

import { SEPARATOR } from '@app/constants/separator'

import styles from './styles.module.scss'

import type { LntSelectProps } from '@app/components/base/Select/types'
import type { CreateListsData } from '@app/api/routes/monitoringLists/types'
import type { CSSProperties } from 'react'
import type { CreateListModalProps } from './types'

const DEFAULT_TITLE = 'Новый список'

const commonSelectProps: LntSelectProps = {
  showArrow: true,
  mode: 'multiple',
  size: SIZE.middle,
  tokenSeparators: [SEPARATOR.newline]
}

const textAreaStyle: CSSProperties = {
  height: 80,
  resize: 'none'
}

export const CreateListModal: React.FC<CreateListModalProps> = props => {
  const { onCreateList, title, ...restProps } = props

  const modalTitle = title ?? DEFAULT_TITLE

  const handleSubmit = (data: CreateListsData): void => onCreateList?.(data)

  return (
    <LntModal
      { ...restProps }
      className={ styles.createListModal }
      title={ modalTitle }
      footer={ null }
      width={ 444 }
    >
      <LntForm
        layout='vertical'
        onSubmit={ handleSubmit }
      >
        <LntFormItem
          name='monitoringTypeIds'
          label='Выберите тип мониторинга'
          defaultValue={ [] }
          validationOptions={ { rules: { required: 'Выберите хотя бы один тип' } } }
          className={ styles.createListModalFormItem }
        >
          <LntSelect
            { ...commonSelectProps }
            placeholder={ `${FILTERS_PLACEHOLDERS.monitoringsTypeFilter} *` }
            querySelect={ {
              queryKey: [MONITORINGS_TYPES_KEY.typesExcludePromoItems],
              queryFn: async () => await getTypes({ excludePromo: true }),
              select: getFilterFromEntities
            } }
          />
        </LntFormItem>

        <LntDivider />

        <LntFormItem
          name='clustersGroupIds'
          label='Выберите область применения'
          defaultValue={ [] }
          className={ styles.createListModalFormItem }
        >
          <LntSelect
            { ...commonSelectProps }
            placeholder={ `${FILTERS_PLACEHOLDERS.clusterGroupsFilter}` }
            querySelect={ {
              queryKey: [LOCATION_KEY.locationClusterGroupsItems],
              queryFn: getClusterGroups,
              select: getFilterFromEntities
            } }
          />
        </LntFormItem>

        <LntFormItem
          name='clusterIds'
          defaultValue={ [] }
          className={ styles.createListModalFormItem }
        >
          <LntSelect
            { ...commonSelectProps }
            placeholder={ `${FILTERS_PLACEHOLDERS.clustersFilter}` }
            querySelect={ {
              queryKey: [LOCATION_KEY.locationClustersItems],
              queryFn: getClusters,
              select: getFilterFromEntities
            } }
          />
        </LntFormItem>

        <LntFormItem
          name='storeIds'
          defaultValue={ [] }
          className={ styles.createListModalFormItem }
        >
          <LntSelect
            { ...commonSelectProps }
            placeholder={ `${FILTERS_PLACEHOLDERS.storesFilter}` }
            querySelect={ {
              queryKey: [LOCATION_KEY.locationStoresItems],
              queryFn: getStores,
              select: getFilterFromEntities
            } }
            disabled
          />
        </LntFormItem>

        <LntFormItem
          name='comment'
          defaultValue=''
          className={ styles.createListModalFormItem }
        >
          <LntTextArea
            placeholder='Примечание'
            style={ textAreaStyle }
            size={ SIZE.middle }
          />
        </LntFormItem>

        <LntModalFooter>
          <LntButton
            type={ BUTTON_TYPE.primary }
            size={ SIZE.middle }
            htmlType='submit'
          >
            Создать список
          </LntButton>
        </LntModalFooter>
      </LntForm>
    </LntModal>
  )
}
